import type { RouteLocationNormalized } from 'vue-router';
import { i18n } from '@/i18n';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import { displayError } from '@/utils/displayError';

export const verifyUser = async (to: RouteLocationNormalized) => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const verificationId = to.query['verification-request-id'] as string;

  try {
    await userStore.verifyUser(verificationId);
    authStore.setIsAuthorized(true);
    return { name: 'root' };
  } catch {
    displayError([i18n.global.t('linkIsNotValid')]);
  }
};
